import React, { memo } from 'react';
import { FormArray } from '@core/utils/form';
import { useObservable } from '@core/utils/hooks/rxjs';
import { ReminderItem } from './ReminderItem';
import { Button } from '@core/components/Button';

export interface SchedulingRemindersProps {
  form: FormArray<any>;
}

export const SchedulingReminders = memo((props: SchedulingRemindersProps) => {
  const { form } = props;
  const items = useObservable(form.items$, []);
  return (
    <div>
      {items.map((item, index) => (
        <ReminderItem key={item.uid} form={item} onRemove={() => form.removeAt(index)} />
      ))}
      <Button onClick={() => form.push()}>Add</Button>
    </div>
  );
});
